import { CellphoneSettingsIcon } from './CellphoneSettingsIcon';

/**
 * author: Google
 * id E7458A8C-66F2-41D7-81AE-4B2B961DFE1A
 * name cellphone-settings
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-settings.svg
 * tags
 * - Cellphone / Phone 
 * - Settings 
 * - Device / Tech 
 */
export const SettingsCellIcon = CellphoneSettingsIcon;
export default SettingsCellIcon